// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full/shared/loadable/Loadable';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* ****My Pages***** */
const NavigationHelpPage = Loadable(lazy(() => import('../my_pages/navigation_help/Page')));
const OverviewPage = Loadable(lazy(() => import('../my_pages/overview/Page')));
const CyberSecurityRiskScorePage = Loadable(lazy(() => import('../my_pages/cybersecurity-risk-score/Page')));
import TargetsPage from 'src/my_pages/targets/Page'; //* Landing Page not lazy
import ResetPass from 'src/my_pages/authentication/reset-password/ResetPass';
import ChangeEmail from 'src/my_pages/authentication/confirm-change-email/ChangeEmail';
import EmailVerifiedPage from 'src/my_pages/authentication/email-verified/EmailVerifiedPage';
import OverviewPage_init from 'src/my_pages/overview/Page_initial';
// const TargetsPage = Loadable(lazy(() => import('../my_pages/targets/Page')));
const HeadersPage = Loadable(lazy(() => import('../my_pages/headers/Page')));
const MaliciousPage = Loadable(lazy(() => import('../my_pages/malicious/Page')));
const StaticCodeAnalysisPage = Loadable(lazy(() => import('../my_pages/static_code_analysis/Page')));
const SecretsPage = Loadable(lazy(() => import('../my_pages/secrets/Page')));
const PortsPage = Loadable(lazy(() => import('../my_pages/ports/Page')));
const SubdomainsPage = Loadable(lazy(() => import('../my_pages/subdomains/Page')));
const TechnologiesPage = Loadable(lazy(() => import('../my_pages/technologies/Page')));
const WafPage = Loadable(lazy(() => import('../my_pages/waf/Page')));
const SubdomainTakeoverPage = Loadable(lazy(() => import('../my_pages/subdomain_takeover/Page')));
const AddNewPage = Loadable(lazy(() => import('../my_pages/add_new/Page')));
const RequestPage = Loadable(lazy(() => import('../my_pages/requests/Page')));
const CertificatesPage = Loadable(lazy(() => import('../my_pages/certificates/Page')));
const DnsPage = Loadable(lazy(() => import('../my_pages/dns/Page')));
const VulnerabilitiesPage = Loadable(lazy(() => import('../my_pages/vulnerabilities/Page')));
const PricingPage = Loadable(lazy(() => import('../my_pages/pricing/Page')));
// const HiddenPathsFilesPage = Loadable(lazy(() => import('src/my_pages/hidden_paths_files/Page.tsx')));
const SensitiveResourcesPage = Loadable(lazy(() => import('src/my_pages/sensitive-resources/Page')));
// const OtherSettingsPage = Loadable(lazy(() => import('src/my_pages/target_settings/pages/OtherSettingsPage')));
// const TargetSettingsPage = Loadable(lazy(() => import('src/my_pages/target_settings/pages/TargetSettingsPage')));
const ProfileTabsContainer = Loadable(lazy(() => import('src/my_pages/profile_settings/TabsContainer')));
const DevComponents = Loadable(lazy(() => import('../my_pages/DEv/Page')));
const GeneratedApiTokenPage = Loadable(lazy(() => import('../my_pages/generated_api_token/Page')));
const FeedbackThankYouPage = Loadable(lazy(() => import('../my_pages/feedback-thank-you/Page')));
const UserManagementPage = Loadable(lazy(() => import('../my_pages/only-admin/user-management/Page')));

//^ --------------------------------------------------------------------------------

// ui components
const MuiAlert = Loadable(lazy(() => import('../views/ui-components/MuiAlert')));
const MuiAccordion = Loadable(lazy(() => import('../views/ui-components/MuiAccordion')));
const MuiAvatar = Loadable(lazy(() => import('../views/ui-components/MuiAvatar')));
const MuiChip = Loadable(lazy(() => import('../views/ui-components/MuiChip')));
const MuiDialog = Loadable(lazy(() => import('../views/ui-components/MuiDialog')));
const MuiList = Loadable(lazy(() => import('../views/ui-components/MuiList')));
const MuiPopover = Loadable(lazy(() => import('../views/ui-components/MuiPopover')));
const MuiRating = Loadable(lazy(() => import('../views/ui-components/MuiRating')));
const MuiTooltip = Loadable(lazy(() => import('../views/ui-components/MuiTooltip')));
const MuiTransferList = Loadable(lazy(() => import('../views/ui-components/MuiTransferList')));
const MuiTypography = Loadable(lazy(() => import('../views/ui-components/MuiTypography')));

// charts
const AreaChart = Loadable(lazy(() => import('../views/charts/AreaChart')));
const CandlestickChart = Loadable(lazy(() => import('../views/charts/CandlestickChart')));
const ColumnChart = Loadable(lazy(() => import('../views/charts/ColumnChart')));
const DoughnutChart = Loadable(lazy(() => import('../views/charts/DoughnutChart')));
const GredientChart = Loadable(lazy(() => import('../views/charts/GredientChart')));
const RadialbarChart = Loadable(lazy(() => import('../views/charts/RadialbarChart')));
const LineChart = Loadable(lazy(() => import('../views/charts/LineChart')));

// tables
const BasicTable = Loadable(lazy(() => import('../views/tables/BasicTable')));
const EnhanceTable = Loadable(lazy(() => import('../views/tables/EnhanceTable')));
const PaginationTable = Loadable(lazy(() => import('../views/tables/PaginationTable')));
const FixedHeaderTable = Loadable(lazy(() => import('../views/tables/FixedHeaderTable')));
const CollapsibleTable = Loadable(lazy(() => import('../views/tables/CollapsibleTable')));

// authentication
const Login = Loadable(lazy(() => import('../my_pages/authentication/login/Login')));
const Login2 = Loadable(lazy(() => import('../my_pages/authentication/login/Login2')));
const Register = Loadable(lazy(() => import('../my_pages/authentication/register/Register')));
const Register2 = Loadable(lazy(() => import('../my_pages/authentication/register/Register2')));
const ForgotPassword = Loadable(lazy(() => import('../my_pages/authentication/forgot-password/ForgotPassword')));
const ForgotPassword2 = Loadable(lazy(() => import('../my_pages/authentication/forgot-password/ForgotPassword2')));
const ChangePasswordForm = Loadable(lazy(() => import('../my_pages/authentication/change-password/ChangePass')));
const TwoSteps = Loadable(lazy(() => import('../my_pages/authentication/two-steps/TwoSteps')));
const TwoSteps2 = Loadable(lazy(() => import('../my_pages/authentication/two-steps/TwoSteps2')));
const Error = Loadable(lazy(() => import('../my_pages/authentication/Error')));
const Maintenance = Loadable(lazy(() => import('../my_pages/authentication/Maintenance')));

export const publicRoutes = [
  { path: '/auth/404', element: <Error /> },
  { path: '/auth/login', element: <Login /> },
  { path: '/auth/register', element: <Register /> },
  { path: '/auth/forgot-password', element: <ForgotPassword2 /> },
  { path: '/auth/change-password', element: <ChangePasswordForm /> },
  { path: '/reset-password', element: <ResetPass /> },
  { path: '/auth/two-steps', element: <TwoSteps2 /> },
  { path: '/auth/maintenance', element: <Maintenance /> },
  { path: '/change-email', element: <ChangeEmail /> },
  { path: '/email-verified', element: <EmailVerifiedPage /> },
  { path: '/generate-api-token', element: <GeneratedApiTokenPage /> },
];

const Router = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      //* - - - - -
      { path: '/', element: <Navigate to="/targets" /> },
      { path: '/add-new', element: <AddNewPage /> },
      { path: '/targets', element: <TargetsPage /> },
      { path: '/navigation', element: <NavigationHelpPage /> },
      { path: '/feedback/thank-you', element: <FeedbackThankYouPage /> },
      { path: '/summary', element: <OverviewPage /> },
      { path: '/cybersecurity-risk-score', element: <CyberSecurityRiskScorePage /> },
      { path: '/summary-old', element: <OverviewPage_init /> },
      //* Settings
      { path: '/user/plan', element: <PricingPage /> },
      { path: '/user-management', element: <UserManagementPage /> },
      // { path: '/target-settings/target', element: <TargetSettingsPage /> },
      // { path: '/target-settings/other', element: <OtherSettingsPage /> },
      // { path: '/generate-api-token', element: <Navigate to="/user/profile?openGenApi=true#integrations" /> }, //! moved to public pages
      { path: '/user/*', element: <ProfileTabsContainer /> },
      //* Vuln. and Threat
      { path: '/threat/headers', element: <HeadersPage /> },
      { path: '/threat/vulnerabilities', element: <VulnerabilitiesPage /> },
      { path: '/threat/secrets', element: <SecretsPage /> },
      { path: '/threat/static-code-analysis', element: <StaticCodeAnalysisPage /> },
      { path: '/threat/malicious', element: <MaliciousPage /> },
      //* Assets
      { path: '/assets/subdomains', element: <SubdomainsPage /> },
      { path: '/assets/technologies', element: <TechnologiesPage /> },
      { path: '/assets/waf', element: <WafPage /> },
      //* Network
      { path: '/network/certificates', element: <CertificatesPage /> },
      { path: '/network/dns', element: <DnsPage /> },
      { path: '/network/ports', element: <PortsPage /> },
      //* Resource and Protection
      { path: '/protection/sensitive-resources', element: <SensitiveResourcesPage /> },
      { path: '/protection/subdomain-takeover', element: <SubdomainTakeoverPage /> },
      // { path: '/protection/hidden-paths-files',element: <HiddenPathsFilesPage /> },
      //* Privacy
      { path: '/privacy/requests', element: <RequestPage /> },
      //* DEV
      { path: '/development/my-devcomps', element: <DevComponents /> },
      //!-----------------------DEV-------------------------------
      // { path: '/ui-components/alert', element: <MuiAlert /> },
      // { path: '/ui-components/accordion', element: <MuiAccordion /> },
      // { path: '/ui-components/avatar', element: <MuiAvatar /> },
      // { path: '/ui-components/chip', element: <MuiChip /> },
      // { path: '/ui-components/dialog', element: <MuiDialog /> },
      // { path: '/ui-components/list', element: <MuiList /> },
      // { path: '/ui-components/popover', element: <MuiPopover /> },
      // { path: '/ui-components/rating', element: <MuiRating /> },
      // { path: '/ui-components/tooltip', element: <MuiTooltip /> },
      // { path: '/ui-components/transfer-list', element: <MuiTransferList /> },
      // { path: '/ui-components/typography', element: <MuiTypography /> },
      // { path: '/tables/basic', element: <BasicTable /> },
      // { path: '/tables/enhanced', element: <EnhanceTable /> },
      // { path: '/tables/pagination', element: <PaginationTable /> },
      // { path: '/tables/fixed-header', element: <FixedHeaderTable /> },
      // { path: '/tables/collapsible', element: <CollapsibleTable /> },
      // { path: '/charts/area-chart', element: <AreaChart /> },
      // { path: '/charts/line-chart', element: <LineChart /> },
      // { path: '/charts/gredient-chart', element: <GredientChart /> },
      // { path: '/charts/candlestick-chart', element: <CandlestickChart /> },
      // { path: '/charts/column-chart', element: <ColumnChart /> },
      // { path: '/charts/doughnut-pie-chart', element: <DoughnutChart /> },
      // { path: '/charts/radialbar-chart', element: <RadialbarChart /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/',
    element: <BlankLayout />,
    children: [
      //
      ...publicRoutes,
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
